import React, { ReactNode } from 'react';
import { ButtonSize, ButtonVariant } from '../../types/button.enum';

interface ButtonProps {
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
  size?: ButtonSize;
  disabled?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  classes?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  type = 'button',
  variant = ButtonVariant.PRIMARY,
  size = ButtonSize.MEDIUM,
  disabled = false,
  fullWidth = false,
  onClick,
  classes = '',
}) => {

  const setButtonStyle = () => {
    if(variant === ButtonVariant.PRIMARY) {
      return 'bg-[#333] text-white';
    }
    else if (variant === ButtonVariant.SECONDARY) {
      return 'bg-transparent text-[#333] border border-[#E2E8F0] hover:bg-[#F2F2F2]';
    }
    else {
      return 'bg-[#e0e0e0] text-[#333]';
    }
  }

  const setButtonSize = () => {
    switch(size) {
      case ButtonSize.SMALL:
        return 'sm:h-[30px] sm:min-w-[60px] sm:text-[12px]';
      case ButtonSize.MEDIUM:
        return 'sm:h-[37px] sm:min-w-[100px] sm:text-[14px]';
      case ButtonSize.LARGE:
        return 'sm:h-[45px] sm:min-w-[150px] sm:text-[16px]';
      default:
        return 'sm:h-[45px] sm:min-w-[150px] sm:text-[16px]';
    }
  }

  return (
    <button
      type={type}
      className={
        `px-4 font-medium
        inline-flex justify-center items-center rounded-lg
        ${disabled ? 'cursor-default opacity-35' : 'cursor-pointer'} ${setButtonSize()} ${setButtonStyle()} ${classes}`
      }
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;